/**
 * Shared FilterChip component — styled pill <select> with active/inactive states.
 * Used across TasksPage, AuditPage, MomsPage, PendingValidationPage,
 * ProjectDetailsPage, and UsersPage.
 *
 * Props:
 *   value    — current selected value (empty string = no filter)
 *   onChange — called with new string value
 *   label    — placeholder text shown when no option is selected
 *   options  — array of { value, label } objects
 */
export default function FilterChip({ value, onChange, label, options }) {
  return (
    <div style={{ position: "relative" }}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        style={{
          padding: "5px 28px 5px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: value ? 600 : 400,
          border: value
            ? "1.5px solid var(--brand)"
            : "1px solid var(--border-strong)",
          background: value ? "var(--brand-soft)" : "var(--surface-2)",
          color: value ? "var(--brand)" : "var(--text-2)",
          cursor: "pointer",
          appearance: "none",
          WebkitAppearance: "none",
          minWidth: 90,
          transition: "all 0.14s",
        }}
      >
        <option value="">{label}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <span
        style={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: 9,
          color: value ? "var(--brand)" : "var(--text-3)",
          pointerEvents: "none",
        }}
      >
        ▼
      </span>
    </div>
  );
}
